import { Link } from 'react-router-dom'
import { getImageUrl } from '../../services/tmdb'
import Rating from '../common/Rating'
import './MovieCard.css'

function MovieCard({ 
  movie, 
  showRating = false, 
  userRating = 0, 
  onClick, 
  compact = false,
  showWatchWith = false 
}) {
  const {
    id,
    tmdbId,
    title,
    poster_path,
    posterPath,
    release_date,
    releaseDate,
    vote_average,
    watchedDate,
    watchWith,
    recommendedBy
  } = movie

  const movieId = tmdbId || id
  const poster = poster_path || posterPath
  const year = (release_date || releaseDate || '').substring(0, 4)
  const tmdbRating = vote_average ? (vote_average / 2).toFixed(1) : null

  const content = (
    <>
      <div className="movie-poster-wrapper">
        {poster ? (
          <img 
            src={getImageUrl(poster, 'w342')} 
            alt={title}
            className="movie-poster"
            loading="lazy"
          />
        ) : (
          <div className="movie-poster-placeholder">
            <svg viewBox="0 0 24 24" width="48" height="48">
              <path fill="currentColor" d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>
            </svg>
          </div>
        )}
        {tmdbRating && (
          <div className="movie-tmdb-rating">
            <svg viewBox="0 0 24 24" width="12" height="12">
              <path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            {tmdbRating}
          </div>
        )}
      </div>
      <div className="movie-info">
        <h3 className="movie-title">{title}</h3>
        <p className="movie-year">{year || 'Sin fecha'}</p>
        {showRating && userRating > 0 && (
          <Rating value={userRating} readonly size="sm" showValue={false} />
        )}
        {watchedDate && (
          <p className="movie-watched-date">
            Visto: {new Date(watchedDate).toLocaleDateString('es-ES')}
          </p>
        )}
        
        {/* Show recommendation tag (movie was recommended by friend) */}
        {showWatchWith && recommendedBy && (
          <div className="movie-watch-tag recommended">
            <span className="tag-label">Recomendada por:</span>
            <span className="tag-name">{recommendedBy.name}</span>
          </div>
        )}
        
        {/* Show "watch with" tag (user selected friends to watch with) */}
        {showWatchWith && !recommendedBy && watchWith?.length > 0 && (
          <div className="movie-watch-tag">
            <span className="tag-label">Ver con:</span>
            <span className="tag-name">{watchWith.map(f => f.name).join(', ')}</span>
          </div>
        )}
      </div>
    </>
  )

  if (onClick) {
    return (
      <div className={`movie-card ${compact ? 'compact' : ''}`} onClick={onClick}>
        {content}
      </div>
    )
  }

  return (
    <Link to={`/movie/${movieId}`} className={`movie-card ${compact ? 'compact' : ''}`}>
      {content}
    </Link>
  )
}

export default MovieCard
